import { Table } from "antd";

export const LectureFeedbackQuestionTable = ({ questions = [] }) => {
  const columns = [
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
      width: 100
    },
    {
      title: "Question",
      dataIndex: "question",
      key: "question"
    }
  ];
  return (
    <Table
      style={{ margin: "10px 0px" }}
      columns={columns}
      dataSource={questions}
      bordered
      pagination={false}
      scroll={{ x: "max-content" }}
    />
  );
};

export const LectureFeedbackTableBasicColumns = () => {
  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Course",
      dataIndex: "courseName",
      key: "courseName"
    },
    {
      title: "Lecture",
      dataIndex: "lectureName",
      key: "lectureName"
    },
    {
      title: "Q1",
      dataIndex: "Q1",
      key: "Q1",
      sorter: (a, b) => a["Q1"] - b["Q1"]
    },
    {
      title: "Q2",
      dataIndex: "Q2",
      key: "Q2",
      sorter: (a, b) => a["Q2"] - b["Q2"]
    },
    {
      title: "Q3",
      dataIndex: "Q3",
      key: "Q3",
      sorter: (a, b) => a["Q3"] - b["Q3"]
    },
    {
      title: "Q4",
      dataIndex: "Q4",
      key: "Q4",
      sorter: (a, b) => a["Q4"] - b["Q4"]
    },
    {
      title: "Total Responses",
      dataIndex: "totalResponses",
      key: "totalResponses",
      sorter: (a, b) => a["totalResponses"] - b["totalResponses"]
    }
  ];

  return columns;
};
